<div class="card special-card" *ngIf="settings.settings.Onboarding">

  <div class="card-body">

    <div class="ps-4">
      <div *ngIf="stepsComplete()" class="row">

        <div class="col-12">
          <div class="d-flex align-items-center">
            <div>
              <h1 class="mb-2">You're good to go!</h1>
              <p class="mb-0">You've completed the 4 important steps to maximise your Socialyze experience.</p>
            </div>
            <button class="btn btn-light btn-xs ms-auto" (click)="dismissDialog()">Dismiss</button>
          </div>
          <h3 class="mt-6 mb-6 h2">Get more out of socialyze</h3>

          <div class="row">
            <ng-container *ngFor="let item of moreOptions">
              <div class="col-lg-4">
                <div class="single-more-option">

                  <div class="icon">
                    <img *ngIf="item.icon" [src]="item.icon" [alt]="item.title">
                  </div>

                  <div class="text">
                    <p class="text-uppercase"><small>{{item.subtitle}}</small></p>
                    <h4 class="mb-0">{{item.title}}</h4>
                  </div>

                </div>
              </div>
            </ng-container>
          </div>

        </div>

      </div>
    </div>

    <div *ngIf="!stepsComplete()" class="row">
      <div class="col-md-5 col-lg-4">

        <div class="pe-5">
          <img src="assets/media/hero-1-img.png" class="w-100">
        </div>

      </div>
      <div class="col-md-7 col-lg-8">
        <div class="d-flex flex-column justify-content-center h-100">
          <div class="d-flex align-items-center">
            <div>
              <h1 class="mb-2">Getting started</h1>
              <p class="mb-0">To maximize your experience, we recommend carrying out the following set up steps.</p>
            </div>
            <button class="btn btn-light btn-xs ms-auto" (click)="dismissDialog()">Dismiss</button>
          </div>
          <div class="row mt-5">

            <div class="col-lg-12 mt-3">
              <div class="single-step">
                <div class="icon">

                </div>
                <div class="text">
                  <h4 class="mb-2">Add your brand</h4>
                  <p>Create a brand in Socialyze to use on campaigns</p>
                </div>
                <div class="button ms-auto">
                  <div class="d-flex complete-step" *ngIf="settings.settings.Onboarding.BrandComplete">
                    <img src="assets/media/icons/custom/success.svg">
                    <h4 class="text-dark mb-0">Complete!</h4>
                  </div>
                  <button *ngIf="!settings.settings.Onboarding.BrandComplete" class="btn btn-dark btn-xs"
                          routerLink="/core/brands/create" [queryParams]="{help: true}">Create Brand
                  </button>
                </div>
              </div>
            </div>

            <div class="col-lg-12 mt-3">
              <div class="single-step">
                <div class="icon">

                </div>
                <div class="text">
                  <h4 class="mb-2">Analyze an influencer</h4>
                  <p>Learn more about about your potential collaborator.</p>
                </div>
                <div class="button ms-auto">
                  <div class="d-flex complete-step" *ngIf="settings.settings.Onboarding.AnalyzeComplete">
                    <img src="assets/media/icons/custom/success.svg">
                    <h4 class="text-dark mb-0">Complete!</h4>
                  </div>
                  <button class="btn btn-dark btn-xs" *ngIf="!settings.settings.Onboarding.AnalyzeComplete" (click)="showAnalyzeVideo()">Learn More</button>
                </div>
              </div>
            </div>

            <div class="col-lg-12 mt-3">
              <div class="single-step">
                <div class="icon">

                </div>
                <div class="text">
                  <h4 class="mb-2">Create a campaign</h4>
                  <p>Once created, you can invite influencers to collaborate.</p>
                </div>
                <div class="button ms-auto">
                  <div class="d-flex complete-step" *ngIf="settings.settings.Onboarding.CampaignComplete">
                    <img src="assets/media/icons/custom/success.svg">
                    <h4 class="text-dark mb-0">Complete!</h4>
                  </div>
                  <button class="btn btn-dark btn-xs"  *ngIf="!settings.settings.Onboarding.CampaignComplete" routerLink="/core/campaigns/create" [queryParams]="{help: true}">Create Campaign</button>
                </div>
              </div>
            </div>

            <div class="col-lg-12 mt-3">
              <div class="single-step">
                <div class="icon">

                </div>
                <div class="text">
                  <h4 class="mb-2">Email Setup</h4>
                  <p>Connect your domain to send invitation emails via Socialyze</p>
                </div>
                <div class="button ms-auto">
                  <div class="d-flex complete-step" *ngIf="settings.settings.Onboarding.EmailSetup">
                    <img src="assets/media/icons/custom/success.svg">
                    <h4 class="text-dark mb-0">Complete!</h4>
                  </div>
                  <button class="btn btn-dark btn-xs"  *ngIf="!settings.settings.Onboarding.EmailSetup" routerLink="/core/admin/settings/email" [queryParams]="{help: true}">Email Setup</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>

</div>
